export const WIDGET_TEXT = 'Your Spotify widget will appear here';
